import { db } from '../firebaseConfig';
import { collection, doc, getDoc, getDocs, serverTimestamp, setDoc } from 'firebase/firestore';
import feedbackIcon from '../img/feedbackIcon.png';
import i18n from "../i18n";

const toMillis = (value) => {
  if (!value) return 0;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (value?.seconds) return value.seconds * 1000;
  if (value instanceof Date) return value.getTime();
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

export async function AdminNotifications(adminUid) {
  try {
    if (!adminUid) {
      return { count: 0, img: null, message: '', url: '' };
    }

    const adminRef = doc(db, 'admin', adminUid);
    const adminSnapshot = await getDoc(adminRef);
    const lastSeenMs = adminSnapshot.exists()
      ? toMillis(adminSnapshot.data()?.lastSeenContactUsAt)
      : 0;

    const contactUsRef = collection(db, 'contactUs');
    const snapshot = await getDocs(contactUsRef);

    const complaintCount = snapshot.docs.reduce((count, complaintDoc) => {
      const createdAtMs = toMillis(complaintDoc.data()?.createdAt);
      if (!lastSeenMs) return count + 1;
      if (!createdAtMs) return count;
      return createdAtMs > lastSeenMs ? count + 1 : count;
    }, 0);

    let img = null;
    let message = '';
    let url = '';

    if (complaintCount > 0) {
      img = feedbackIcon;
      message = i18n.t("admin_notifications_complaint_message");
      url = '/06071966/contactUs';
    }

    return {
      count: complaintCount,
      img,
      message,
      url, 
    };
  } catch (error) {
    console.error('Error getting contactUs count:', error);
    throw error;
  }
}

export async function markAdminNotificationsSeen(adminUid) {
  if (!adminUid) return;
  await setDoc(
    doc(db, 'admin', adminUid),
    { lastSeenContactUsAt: serverTimestamp() },
    { merge: true }
  );
}
